import { useCallback } from 'react'
import { AdditionalDetails } from '../../../../../types/FirestoreUser'

const useUpdateAdditionalDetails = (
  setAdditionalDetails: React.Dispatch<
    React.SetStateAction<Partial<AdditionalDetails>>
  >
) => {
  const update = useCallback(
    (partial: Partial<AdditionalDetails>) => {
      setAdditionalDetails((prevDetails: any) => ({
        ...prevDetails,
        ...partial,
        alsOnset: partial.alsOnset ?? prevDetails.alsOnset ?? undefined,
        alsOnsetClassification:
          partial.alsOnsetClassification ??
          prevDetails.alsOnsetClassification ??
          undefined,
        familialGene:
          partial.familialGene ?? prevDetails.familialGene ?? undefined,
        contributingFactors: {
          ...prevDetails.contributingFactors,
          ...partial.contributingFactors,
        },
        symptoms: partial.symptoms ?? prevDetails.symptoms ?? [],
      }))
    },
    [setAdditionalDetails]
  )

  return update
}

export default useUpdateAdditionalDetails
